import {Stack, styled} from '@mui/material'

export const ModalContentWrapper = styled(Stack)(() => ({
  alignItems: 'center',
  columnGap: 15,
  flexDirection: 'row',
}))

export const pdfViewStyle = {border: 'none'}
